// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1By_F","colMin":"styles_colMin__1giEd"};